
import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import EnvEnum from '@/enum/EnvEnum';

function getEnvironment() {
  const environment = Object.keys(EnvEnum)
    .find(env => window.location.origin === EnvEnum[env].url);

  return environment ? EnvEnum[environment].name : EnvEnum.LOCAL.name;
}

function getAPIEnvironment() {
  return localStorage.getItem('Exporo.API.env');
}

export default function configSentry() {
  // configure Sentry
  const environment = getEnvironment();

  // allow error tracking in staging / prod
  if (environment !== EnvEnum.LOCAL.name) {
    Sentry.init({
      dsn: 'https://ef1869a8e80942a5b3606a8ed3a7af6f@sentry.io/1552452',
      integrations: [new Integrations.Vue({ Vue, attachProps: true })],
      environment,
    });
    // Set user information, as well as tags and further extras
    Sentry.configureScope((scope) => {
      scope.setTag('API environment', getAPIEnvironment());
    });
  }
}



// WEBPACK FOOTER //
// ./src/plugins/sentry.js